/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  affixProps: {
    type: Object
  },
  bounds: {
    type: Number,
    "default": 5
  },
  container: {
    type: [String, Function],
    "default": function _default() {
      return function () {
        return window;
      };
    }
  },
  cursor: {
    type: Function
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      return ["small", "medium", "large"].includes(val);
    }
  },
  targetOffset: {
    type: Number,
    "default": 0
  },
  onChange: Function,
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
